import React, { useEffect, useState } from 'react';
import { FileText, FileXls, FileDoc, FilePpt } from '@phosphor-icons/react';

const OFFICE_EXT = /\.(xlsx|xlsm|xlsb|xls|docx|docm|doc|rtf|pptx|pptm|ppt|odt|ods|odp)$/i;
const XLS = /\.(xlsx|xlsm|xlsb|xls|ods)$/i;
const PPT = /\.(pptx|pptm|ppt|odp)$/i;

const fmtMB = (b) => `${(Number(b || 0) / 1048576).toFixed(1)} MB`;

/** 選んだファイルを登録前に確認する。画像とPDFはその場で、Officeは登録後に変換される旨を示す。 */
export function UploadFilePreview({ file }) {
  const [url, setUrl] = useState(null);
  const isImage = (file?.type || '').startsWith('image/');
  const isPdf = (file?.type || '') === 'application/pdf' || /\.pdf$/i.test(file?.name || '');
  const isOffice = OFFICE_EXT.test(file?.name || '');

  useEffect(() => {
    if (!file || !(isImage || isPdf)) { setUrl(null); return undefined; }
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file, isImage, isPdf]);

  if (!file) return null;

  const Icon = XLS.test(file.name) ? FileXls : PPT.test(file.name) ? FilePpt
    : /\.(docx|docm|doc|rtf|odt)$/i.test(file.name) ? FileDoc : FileText;

  return (
    <div className="rounded-lg border border-zinc-200 bg-zinc-50 overflow-hidden"
      data-testid="dms-upload-preview">
      {isImage && url && (
        <img src={url} alt={file.name} className="max-h-48 mx-auto object-contain bg-white" />
      )}
      {isPdf && url && (
        <iframe title="upload-preview" src={url} className="w-full h-48 bg-white" />
      )}
      {!isImage && !isPdf && (
        <div className="py-5 text-center text-zinc-500">
          <Icon size={30} weight="duotone" className="mx-auto mb-1.5 text-teal-600" />
          <p className="text-xs font-medium text-zinc-700 truncate px-3">{file.name}</p>
          <p className="text-[11px] mt-0.5">
            {fmtMB(file.size)}
            {isOffice ? ' · 登録すると PDF に変換してプレビューできます' : ' · プレビュー非対応形式'}
          </p>
        </div>
      )}
      {(isImage || isPdf) && (
        <p className="text-[10px] text-zinc-500 text-center py-1">{file.name} · {fmtMB(file.size)}</p>
      )}
    </div>
  );
}

export default UploadFilePreview;
